export default {"src":"/encomendas-static/_next/static/media/length-icon.7fa2a9a4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};